import React from "react";
import { Radio, Tooltip } from "antd";
import RadioButtonProps from "../types/RadioButtonProps";

const RadioButtonForTracktor: React.FC<{ title: string; value: number }> = ({
    title,
    value,
}: RadioButtonProps) => (
    <>
        <Radio.Button value={value}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                <path
                    d="M396.5,254.55c-24.4,0-47.2,9.6-64.2,26.9c-17,17.4-26.4,40.6-26.4,65.5c0,50.9,40.7,92.3,90.6,92.3
	c24.7,0,47.7-9.6,64.9-27.2c17.1-17.4,26.5-40.6,26.5-65.2C487.9,295.15,447.7,254.55,396.5,254.55z M396.5,419.25
	c-38.9,0-70.6-32.4-70.6-72.3c0-40.5,31-72.3,70.6-72.3c40,0,71.4,31.8,71.4,72.3C467.9,386.85,435.9,419.25,396.5,419.25z
	 M61.3,316.35c-34.4,0-61.3,26.8-61.3,61c0,16.6,6.3,32.2,17.8,43.8c11.5,11.7,26.9,18.1,43.4,18.1l0,0c33.9,0,60.4-27.1,60.6-61.9
	C121.8,343.15,95.2,316.35,61.3,316.35z M61.2,419.25c-23.2,0-41.3-18.4-41.3-41.9c0-23,18.2-41,41.3-41c23,0,40.4,17.7,40.5,41
	C101.7,400.85,83.9,419.25,61.2,419.25z M407.1,131.15c-5.5,0-10,4.5-10,10v51.7h-40.5c-5.5,0-10,4.5-10,10s4.5,10,10,10h50.5
	c5.5,0,10-4.4,10-10v-61.7C417.1,135.65,412.6,131.15,407.1,131.15z M396.5,305.65c-22.1,0-40.1,18.5-40.1,41.3
	c0,22,18.4,40.5,40.1,40.5c22.6,0,40.9-18.2,40.9-40.5C437.4,324.15,419.1,305.65,396.5,305.65z M396.5,367.45
	c-10.7,0-20.1-9.6-20.1-20.5c0-11.6,9.2-21.3,20.1-21.3c11.5,0,20.9,9.6,20.9,21.3C417.4,358.05,407.8,367.45,396.5,367.45z
	 M443.5,243.25l27.2,28.2c3.8,4,10.2,4.1,14.1,0.3c4-3.7,4.1-10.1,0.3-14.1l-27.3-28.4V58.75c0-5.5-4.5-10-10-10H264.7
	c-4.5,0-8.5,3.1-9.7,7.4l-38.7,146.5H111.8c0-0.2,0-0.5,0-0.7V58.65c0-5.5-4.5-10-10-10H71.7c-5.5,0-10,4.5-10,10s4.5,10,10,10h20.2
	v133.3c0,0.2,0,0.5,0,0.7H51.4c-5.5,0-10,4.5-10,10v71.6c0,0.2,0,0.5,0,0.7H31c-2.7,0-5.2,1.1-7.1,3l-20.3,20.6
	c-3.9,3.9-3.8,10.3,0.1,14.1c3.9,3.9,10.3,3.8,14.1-0.1l17.4-17.6h71.4l37.8,67.4c1.8,3.2,5.1,5.1,8.7,5.1h111.5
	c3.9,0,7.5-2.3,9.1-5.9l58.4-128.3H443.5z M258.2,357.55H159l-37.8-67.4c-1.8-3.2-5.1-5.1-8.7-5.1H61.4c0-0.2,0-0.5,0-0.7v-61.6
	h152.5v51.8c0,5.5,4.5,10,10,10h67.5L258.2,357.55z M325.7,223.35c-3.9,0-7.5,2.3-9.1,5.9l-16.1,35.3h-66.6v-41.8h40.5
	c3.8,0,7.3-2.2,9-5.6l18.9-38.2l18.3,11c1.6,1,3.4,1.4,5.2,1.4c3.4,0,6.7-1.7,8.6-4.8c2.9-4.7,1.3-10.9-3.4-13.7l-50.5-30.5
	c-4.7-2.9-10.9-1.3-13.7,3.4c-2.9,4.7-1.3,10.9,3.4,13.7l15,9.1l-16.9,34.1h-31.4l35.4-134h165.4v154.5h-112L325.7,223.35
	L325.7,223.35z"
                    fill="#164B84"
                    strokeWidth={12}
                />
            </svg>
            <Tooltip title={title}>
                <h5>{title}</h5>
            </Tooltip>
        </Radio.Button>
    </>
);

export default RadioButtonForTracktor;
